import graphql from './graphql';
import { UserListUsersByCourse, CourseEnrollUsers, UserCourseDeleteUser, CourseContentCount } from './Request';

const mapUsers = (users, totalEvaluations) =>
  users?.map(user => [
    user?.User?.fullName,
    user?.User?.Department?.name,
    user?.User?.JobTitle?.name,
    user?.User?.Terminal?.name,
    {
      totalLessonsCompletedManual: user?.User?.UserEvaluations?.totalLessonsCompletedManual,
      totalLessonsCompletedAutomatic: user?.User?.UserEvaluations?.totalLessonsCompletedAutomatic,
      totalLessonsCount: totalEvaluations,
    },
    user?.User?.id,
    user?.wasUserEnrolled,
  ]);
const mapCourseTotals = courses => courses?.evaluationCount;
const mapGeneric = array => array?.map(item => item.name || '');

export const fetchCourseUsers = async ({
  courseId,
  fullName = '',
  department = null,
  jobTitle = null,
  terminal = null,
}) => {
  const promises = [];
  promises.push(
    UserListUsersByCourse({
      courseId,
      fullName,
      department,
      jobTitle,
      terminal,
    })
  );
  promises.push(
    graphql(
      'User_list',
      ['id', 'fullName', 'status', 'Department {name}', 'Terminal {name}', 'JobTitle {name}', 'payrollNum'],
      'query'
    )
  );

  const data = await Promise.all(promises);
  const courseTotalObject = await CourseContentCount({ courseId });
  const courseTotal = mapCourseTotals(courseTotalObject);
  const courseUsersByCourse = data[0] ?? [];
  const courseUsers = mapUsers(courseUsersByCourse, courseTotal);
  const courseUserIds = courseUsersByCourse.map(user => user.User.id);
  // El backend devuelve `User_list: null` y un errors[].extensions.code
  // (FORBIDDEN/UNAUTHORIZED) si el rol no tiene permiso `employee.*`. El
  // wrapper graphql ya normalizó esa respuesta a `{ error, errorCode }`, así
  // que aquí basta caer a [] para que la UI no crashee.
  const userList = data[1]?.User_list ?? [];
  const activeUsers = userList.filter(item => !courseUserIds.includes(item.id) && item.status === true);

  return { courseUsers, users: activeUsers };
};

export const fetchDropdownsInformation = async () => {
  const promises = [];
  promises.push(graphql('Department_list', 'name', 'query'));
  promises.push(graphql('JobTitle_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));

  const data = await Promise.all(promises);

  // Cualquiera de estos puede venir nulo si el rol no tiene `employee.*`; el
  // wrapper normaliza errors[] de GraphQL pero el campo en `data` se mantiene
  // como null. Se cae a [] para que los dropdowns simplemente queden vacíos.
  const departments = mapGeneric(data[0]?.Department_list ?? []);
  const jobTitles = mapGeneric(data[1]?.JobTitle_list ?? []);
  const terminals = mapGeneric(data[2]?.Terminal_list ?? []);

  return { departments, jobTitles, terminals };
};

export const enrollUsers = async (courseId, users) => CourseEnrollUsers(courseId, users);

export const userCourseDeleteUser = async (courseId, userId) => UserCourseDeleteUser(courseId, userId);

export default {
  fetchCourseUsers,
  fetchDropdownsInformation,
  enrollUsers,
  userCourseDeleteUser,
};
